(function () {
  if (window.__productRichtextCtaBound) return;
  window.__productRichtextCtaBound = true;

  function norseRichtextCtaHydratePrices(root) {
    var container = root && root.querySelectorAll ? root : document;
    var hits = container.querySelectorAll('[data-product-richtext-cta][data-norse-price]');
    for (var i = 0; i < hits.length; i++) {
      norseRichtextCtaHydrateOne(hits[i]);
    }
  }

  function norseRichtextCtaHydrateOne(hit) {
    var price = hit.getAttribute('data-norse-price');
    if (!price) return;
    var rte = hit.querySelector('.product-richtext-cta__rte');
    if (!rte) return;
    var markup = '<span class="product-richtext-cta__price">' + price + '</span>';
    var html = rte.innerHTML;
    var next = html
      .replace(/\{\{\s*price\s*\}\}/gi, markup)
      .replace(/\[\[\s*price\s*\]\]/gi, markup)
      .replace(/[\u007B\uFF5B]\s*price\s*[\u007D\uFF5D]/gi, markup);
    if (next !== html) rte.innerHTML = next;
  }

  norseRichtextCtaHydratePrices(document);
  document.addEventListener('DOMContentLoaded', function () {
    norseRichtextCtaHydratePrices(document);
  });
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target) norseRichtextCtaHydratePrices(ev.target);
  });

  function getCartUi() {
    return (
      document.querySelector('cart-notification') ||
      document.querySelector('#CartDrawer')?.closest('cart-drawer') ||
      document.querySelector('cart-drawer')
    );
  }

  function cartAddJsUrl() {
    const r = typeof routes !== 'undefined' ? routes : window.routes;
    const u = r.cart_add_url || '/cart/add';
    return /\.js(\?|$)/.test(String(u)) ? u : `${String(u).replace(/\/?$/, '')}.js`;
  }

  function getVariantIdsFromTrigger(trigger) {
    const idsJson = trigger.getAttribute('data-variant-ids');
    if (idsJson) {
      try {
        const parsed = JSON.parse(idsJson);
        if (Array.isArray(parsed) && parsed.length) {
          return parsed.map((id) => String(id));
        }
      } catch (err) {
        /* fall through */
      }
    }

    const single = trigger.getAttribute('data-variant-id');
    return single ? [String(single)] : [];
  }

  function addVariantFromTrigger(trigger) {
    if (!trigger || trigger.getAttribute('aria-disabled') === 'true') return;

    const variantIds = getVariantIdsFromTrigger(trigger);
    if (!variantIds.length) return;

    const cart = getCartUi();
    const r = typeof routes !== 'undefined' ? routes : window.routes;
    const body = {
      items: variantIds.map((id) => ({ id, quantity: 1 })),
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    trigger.setAttribute('aria-disabled', 'true');

    fetch(cartAddJsUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-richtext-cta',
              productVariantId: variantIds[0],
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        if (!cart) {
          window.location.href = r.cart_url;
          return;
        }

        if (typeof CartPerformance !== 'undefined' && CartPerformance.measure) {
          CartPerformance.measure('norse-richtext-cta:paint-updated-sections', () => {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-richtext-cta',
                productVariantId: variantIds[0],
                cartData: response,
              });
            }
            cart.renderContents(response);
          });
        } else {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-richtext-cta',
              productVariantId: variantIds[0],
              cartData: response,
            });
          }
          cart.renderContents(response);
        }
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        trigger.removeAttribute('aria-disabled');
      });
  }

  document.body.addEventListener('click', function (e) {
    const hit = e.target.closest('[data-product-richtext-cta]');
    if (!hit) return;

    if (e.target.closest('a')) return;

    e.preventDefault();

    addVariantFromTrigger(hit);
  });

  document.body.addEventListener('keydown', function (e) {
    if (e.code !== 'Enter' && e.code !== 'Space') return;
    const hit = e.target.closest('[data-product-richtext-cta]');
    if (!hit || hit !== document.activeElement) return;
    e.preventDefault();
    addVariantFromTrigger(hit);
  });
})();
